import ExcelJS from "exceljs";

export default class ReporteMonederosExcel {
  static generateWorkbook(data) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Monederos");

    // Título principal
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "MONEDEROS";
    worksheet.mergeCells("A1:F1");
    titleCell.font = { name: "Arial", size: 16, bold: true };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9D9D9" }, // Gris claro
    };
    worksheet.getRow(1).height = 30;

    // Marca de tiempo
    const now = new Date();
    const generatedDate = now.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const generatedTime = now.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    const dateCell = worksheet.getCell("A2");
    dateCell.value = `Generado: ${generatedDate}`;
    worksheet.mergeCells("A2:F2");
    dateCell.alignment = { horizontal: "left" };

    const timeCell = worksheet.getCell("A3");
    timeCell.value = `Hora: ${generatedTime}`;
    worksheet.mergeCells("A3:F3");
    timeCell.alignment = { horizontal: "left" };

    worksheet.addRow([]); // Fila 4

    // Definir ancho de columnas
    worksheet.columns = [
      { key: "Movimientos", width: 50 }, // Col A
      { key: "Cantidad", width: 30 }, // Col B
      { key: "CantidadMXN", width: 30 }, // Col C
      { key: "SaldosAntes", width: 40 }, // Col D
      { key: "TipoDespues", width: 40 }, // Col E
      { key: "Tipo", width: 10 }, // Col F
    ];

    // Encabezados de las transacciones
    const txHeaders = [
      "Movimientos",
      "Cantidad",
      "Cantidad MXN",
      "Saldo Antes Mov.",
      "Saldo Desp. Mov.",
      "Tipo",
    ];

    // Bucle por cada cliente
    data.forEach((client, index) => {
      // Fila de encabezado del cliente
      const saldo = parseFloat(client.Monedero?.Saldo) || 0;
      const formattedBalance = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(saldo);

      const clientName = `${client.NombreCompleto || ""}${
        client.Apodo ? " " + client.Apodo : ""
      } Saldo: ${formattedBalance}`;

      const clientHeaderRow = worksheet.addRow([clientName]);
      const clientHeaderCell = clientHeaderRow.getCell(1);
      worksheet.mergeCells(
        clientHeaderRow.number,
        1,
        clientHeaderRow.number,
        6
      ); // Merge A:F

      clientHeaderCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9D9D9" }, // Gris claro
      };
      clientHeaderCell.font = {
        name: "Arial",
        size: 14,
        bold: true,
        italic: true,
      };
      clientHeaderRow.height = 25;

      // Fila de encabezados de transacciones
      const txHeaderRow = worksheet.addRow(txHeaders);
      txHeaderRow.font = { name: "Arial", size: 12, bold: true };
      txHeaderRow.alignment = { horizontal: "center" };
      txHeaderRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFBFBFBF" }, // Gris medio
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // Filas de datos de movimientos
      const movimientos = client.MovimientosMonedero || [];

      if (movimientos.length === 0) {
        // Añadir fila si no hay movimientos
        const noDataRow = worksheet.addRow(["Sin movimientos", "", "", "", ""]);
        worksheet.mergeCells(noDataRow.number, 1, noDataRow.number, 5);
        noDataRow.getCell(1).alignment = {
          horizontal: "center",
          vertical: "top",
        };
        noDataRow.getCell(1).font = { italic: true };
      } else {
        movimientos.forEach((mov) => {
          // Columna A: Movimientos
          const desc = mov.Descripcion || "N/A";
          const fecha = mov.Fecha ? `Fecha: ${mov.Fecha}` : "";
          const origen = mov._m && mov._m.og ? mov._m.og : "";
          const cellA_Value = [desc, fecha, origen].filter(Boolean).join("\n");

          // Columna B: Cantidad
          const cellB_Value = parseFloat(mov.Cantidad) || 0;

          // Columna C: Cantidad MXN
          const cellC_Value = parseFloat(mov.Cantidad) || 0;

          // Columna D: Saldos
          const cellD_Value = parseFloat(mov.SaldoAnterior);
          const cellE_Value = parseFloat(mov.SaldoPosterior);

          // Columna E: Tipo
          const cellF_Value = mov._Op || "";

          // Añadir la fila
          const dataRow = worksheet.addRow([
            cellA_Value,
            cellB_Value,
            cellC_Value,
            cellD_Value,
            cellE_Value,
            cellF_Value,
          ]);

          // Aplicar estilos a la fila
          dataRow.getCell(1).alignment = {
            vertical: "top",
            wrapText: true,
          }; // Movimientos
          dataRow.getCell(2).numFmt = "#,##0.00"; // Cantidad
          dataRow.getCell(2).alignment = { vertical: "top" };
          dataRow.getCell(3).numFmt = "#,##0.00"; // Cantidad MXN
          dataRow.getCell(3).alignment = { vertical: "top" };
          dataRow.getCell(4).numFmt = "#,###,##0.00"; // Saldos Antes
          dataRow.getCell(4).alignment = {
              vertical: "top",
              horizontal: "center",
            }; // Saldos Antes
            dataRow.getCell(5).numFmt = "#,###,##0.00"; // Saldos Despues
            dataRow.getCell(5).alignment = {
            vertical: "top",
            horizontal: "center",
          }; // Saldos Despues
          dataRow.getCell(6).alignment = {
            vertical: "top",
            horizontal: "center",
          }; // Tipo

          // Bordes para celdas de datos
          dataRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });
      }
    });

    return workbook;
  }

  static async generateExcelBuffer(data) {
    const workbook = ReporteMonederosExcel.generateWorkbook(data);
    return await workbook.xlsx.writeBuffer();
  }
}
